export default "__VITE_ASSET__CLSARYhE__"